import { render, staticRenderFns } from "./VerDocCertificados.vue?vue&type=template&id=6178352e&"
import script from "./VerDocCertificados.vue?vue&type=script&lang=js&"
export * from "./VerDocCertificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports